import { createApiClient } from './apiClient'
import { User } from '../types/auth'

export interface UpdateProfilePayload {
  name?: string
  email?: string
  locale?: string
}

export interface ChangePasswordPayload {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}

export interface ValidationError {
  message: string
  code: string
  violations?: { propertyPath: string; message: string }[]
}

export const profileService = (token: string | null) => {
  const api = createApiClient(token)

  return {
    get: () => api.get<User>('/api/profile'),

    update: (data: UpdateProfilePayload) => api.put<User>('/api/profile', data),

    changePassword: (data: ChangePasswordPayload) =>
      api.put<{ message: string }>('/api/profile/password', data),
  }
}
